import UtilNumeroProcesso from "@/utils/UtilNumeroProcesso";
import { action, computed, makeObservable, observable } from "mobx";
import { CategoriaMinuta, IEtiqueta, IUsuario, OrigemProcesso } from "../modelo";
import { IAutocomplete } from "../modelo/Autocomplete";
import { FiltroTriagem } from "../modelo/Triagem";
import { PeticaoPendente } from "../modelo/PeticaoApreciada";
import EscaninhoStore from "./EscaninhoStore";
import FiltroAutoCompleteStore from "./FiltroAutoCompleteStore";
import FiltroStore from "./FiltroStore";
import RouterStore from "./RouterStore";

class BaseFiltroStore {


    filtroAplicado: boolean;
    possuiResponsavel: boolean;
    naoPossuiResponsavel: boolean;
    possuiRedatorDesignado: boolean;
    processoRetornandoAoGabinete: boolean;
    possuiMinutaDespacho: boolean;
    possuiMinutaDecisao: boolean;
    possuiMinutaVoto: boolean;
    possuiMinutaVotoAgravoProvido: boolean;
    naoPossuiMinuta: boolean;
    foraDoGabineteFilter: boolean;
    incluirForaDoGabineteFilter: boolean;
    julgadoFilter: boolean;
    naoJulgadoFilter: boolean;
    tipoJulgamentoPresencialFilter: boolean;
    tipoJulgamentoVirtualFilter: boolean;
    publicavelFilter: boolean;
    naoPublicavelFilter: boolean;
    favoritoFilter: boolean;
    naoFavoritoFilter: boolean;
    possuiPeticaoPendente: boolean;
    naoPossuiPeticaoPendente: boolean;
    possuiImpedimento: boolean;
    assinavel: boolean;
    orgaoJudicanteSelecionadoFilter: string[];
    andTramTarefasSelecionadoFilter: string[];
    tipoPeticaoSelecionadaFilter: string[];
    dataInicioPeticaoFilter: string = '';
    dataFimPeticaoFilter: string = '';
    dataInicioPeticaoAplicada: string = '';
    dataFimPeticaoAplicada: string = '';
    motivoImpedimentoSelecionadoFilter: string[];
    tarefaSelecionadaFilter: string[];
    usuarioSelecionadoFilter: string[];
    etiquetaSelecionadaFilter: IEtiqueta[];
    indicadorSelecionadoFilter: string[];
    categoriaProcessoFilter: CategoriaMinuta[];
    situacaoMinutaFilter: string[];
    revisorPautaFilter: string[];
    statusRevisaoFilter: string[];
    unidadePublicadoraFilter: string[];
    resultadoJulgamentoFilter: string[];
    listaDeNumeroProcessoFilter: string;
    textoTriagemFilter: string;
    tipoMinutaFilter: string[];
    classeProcessoFilter: string[];
    temaProcessoFilter: string[];
    classeInteiraFilter: string[];
    classeInicialProcessoFilter: string[];
    numeroProcessoFilter: string;
    digitoProcessoFilter: string;
    anoProcessoFilter: string;
    orgaoProcessoFilter: string;
    regionalProcessoFilter: string;
    varaProcessoFilter: string;
    assuntoFilter: string[];
    nomeParteFilter: string;
    parteFilter: string;
    pautaFilter: string[];
    movimentosFilter: string[];
    origem: OrigemProcesso;
    nomeStore: string;
    anoAutuacaoFilter: string[];
    situacaoPeticaoFilter: string = '';
    camposDeTriagemValorCondenacaoFilter: string;
    camposDeResponsavelPelaTriagemFilter: IUsuario[];
    camposDeTriagemBooleanFilter: FiltroTriagem[];
    usuariosUltimaAlteracaoSituacaoMinutaFilter: IUsuario[];
    filtrosFilter: string[] = [];
    votoLiberadoFilter: boolean;
    votoNaoLiberadoFilter: boolean;
    relatorProcessoFilter: string[];
    correJuntoFilter: boolean;
    associadoFilter: boolean;

    constructor() {
        makeObservable(this, {
            filtroAplicado: observable,
            possuiResponsavel: observable,
            naoPossuiResponsavel: observable,
            possuiRedatorDesignado: observable,
            processoRetornandoAoGabinete: observable,
            possuiMinutaDespacho: observable,
            possuiMinutaDecisao: observable,
            possuiMinutaVoto: observable,
            possuiMinutaVotoAgravoProvido: observable,
            naoPossuiMinuta: observable,
            foraDoGabineteFilter: observable,
            incluirForaDoGabineteFilter: observable,
            julgadoFilter: observable,
            naoJulgadoFilter: observable,
            tipoJulgamentoPresencialFilter: observable,
            tipoJulgamentoVirtualFilter: observable,
            publicavelFilter: observable,
            naoPublicavelFilter: observable,
            favoritoFilter: observable,
            naoFavoritoFilter: observable,
            possuiPeticaoPendente: observable,
            naoPossuiPeticaoPendente: observable,
            possuiImpedimento: observable,
            assinavel: observable,
            orgaoJudicanteSelecionadoFilter: observable,
            andTramTarefasSelecionadoFilter: observable,
            tipoPeticaoSelecionadaFilter: observable,
            dataInicioPeticaoFilter: observable,
            dataFimPeticaoFilter: observable,
            dataInicioPeticaoAplicada: observable,
            dataFimPeticaoAplicada: observable,
            motivoImpedimentoSelecionadoFilter: observable,
            tarefaSelecionadaFilter: observable,
            usuarioSelecionadoFilter: observable,
            etiquetaSelecionadaFilter: observable,
            indicadorSelecionadoFilter: observable,
            categoriaProcessoFilter: observable,
            situacaoMinutaFilter: observable,
            revisorPautaFilter: observable,
            statusRevisaoFilter: observable,
            unidadePublicadoraFilter: observable,
            resultadoJulgamentoFilter: observable,
            listaDeNumeroProcessoFilter: observable,
            textoTriagemFilter: observable,
            tipoMinutaFilter: observable,
            classeProcessoFilter: observable,
            temaProcessoFilter: observable,
            classeInteiraFilter: observable,
            classeInicialProcessoFilter: observable,
            numeroProcessoFilter: observable,
            digitoProcessoFilter: observable,
            anoProcessoFilter: observable,
            orgaoProcessoFilter: observable,
            regionalProcessoFilter: observable,
            varaProcessoFilter: observable,
            assuntoFilter: observable,
            nomeParteFilter: observable,
            parteFilter: observable,
            pautaFilter: observable,
            movimentosFilter: observable,
            origem: observable,
            nomeStore: observable,
            anoAutuacaoFilter: observable,
            situacaoPeticaoFilter: observable,
            camposDeTriagemValorCondenacaoFilter: observable,
            camposDeResponsavelPelaTriagemFilter: observable,
            camposDeTriagemBooleanFilter: observable,
            usuariosUltimaAlteracaoSituacaoMinutaFilter: observable,
            filtrosFilter: observable,
            votoLiberadoFilter: observable,
            votoNaoLiberadoFilter: observable,
            relatorProcessoFilter: observable,
            correJuntoFilter: observable,
            associadoFilter: observable,
            inicializar: action,
            filtrosAutoComplete: computed,
            numerosNoFiltro: computed,
            limparNumero: action,
            limparTiposMinuta: action,
            limparPossuiPeticaoPendenteETiposPeticao: action,
            limparNaoPossuiPeticaoPendente: action,
            limparPossuiImpedimentoETiposImpedimento: action,
            limparFiltro: action,
            getNumeroProcesso: action,
            numeroProcessoInformado: computed,
            possuiIntervaloDataPeticao: computed,
            intervaloDataPeticaoInvalido: computed,
            descricaoIntervaloDataPeticao: computed,
            aplicarIntervaloDataPeticao: action,
            limparFiltrosBase: action
        });
    }

    inicializar = () => {
        if (!this.filtroAplicado) {
            this.limparFiltros();
        }
    };

    get etiquetasUnicasParaAutoComplete(): IAutocomplete<IEtiqueta>[] {
        throw new Error('Implementa ai');
    }

    get partesUnicosFormatoAutoComplete(): IAutocomplete<string>[] {
        throw new Error('Implementa ai');
    }

    get impedimentosAutocomplete(): IAutocomplete<string>[] {
        throw new Error('Implementa ai');
    }

    retornaValoresUnicosDeUmArray = (array: any[], id: string) => {
        const retornoComValoresUnicos = [];
        array.forEach(param => {
            const achou = retornoComValoresUnicos.find(unico => unico[id] === param[id]);
            if (!achou) {
                retornoComValoresUnicos.push({ ...param });
            }
        });
        return retornoComValoresUnicos;
    }

    get assuntosUnicosFormatoAutoComplete(): IAutocomplete<string>[] {
        throw new Error('Implementa ai');
    }

    get tiposPeticaoPendenteAutocomplete(): IAutocomplete<string>[] {
        throw new Error('Implementa ai');
    }

    // As listas de opções abaixo vivem no FiltroAutoCompleteStore; os getters seguem
    // como fachada para manter a API pública (herdada por FiltroStore) inalterada.
    get tarefasAutoComplete() {
        return FiltroAutoCompleteStore.tarefasAutoComplete;
    }

    get usuariosAutoComplete() {
        return FiltroAutoCompleteStore.usuariosAutoComplete;
    }

    get relatorAutoComplete() {
        return FiltroAutoCompleteStore.relatorAutoComplete;
    }

    get indicadoresAutoComplete() {
        return FiltroAutoCompleteStore.indicadoresAutoComplete;
    }

    get andTramTarefas() {
        return FiltroAutoCompleteStore.andTramTarefas;
    }

    get anoAutuacao() {
        return FiltroAutoCompleteStore.anoAutuacao;
    }

    get filtrosAutoComplete() {
        return FiltroStore.listaFiltros
            .map(filtro => {
                const nomeFormatado = FiltroStore.formataNomeFiltro(filtro.texto);
                if (nomeFormatado === 'Filtro não encontrado') {
                    return null;
                }
                const retorno: IAutocomplete<string> = {
                    texto: nomeFormatado,
                    valor: filtro.valor,
                    parametrosBusca: [filtro.texto, filtro.valor, nomeFormatado]
                };
                return retorno;
            })
            .filter(Boolean) as IAutocomplete<string>[];
    }

    get numerosNoFiltro(): string[] {
        if (!this.listaDeNumeroProcessoFilter) {
            return [];
        }

        const numerosNoFiltro = this.listaDeNumeroProcessoFilter
            .split(/;|\n/)
            .map(num => num?.trim())
            .filter(num => num?.length > 0)
            .flatMap((item) => {
                const numerosExtraidos = UtilNumeroProcesso.extrairNumerosProcessoDeTexto(item);
                if (numerosExtraidos.length > 0) {
                    return numerosExtraidos;
                }
                return item;
            });

        if (numerosNoFiltro.length === 0) {
            return [];
        }
        return numerosNoFiltro;
    }

    limparNumero = () => {
        this.numeroProcessoFilter = "";
        this.digitoProcessoFilter = "";
        this.anoProcessoFilter = "";
        this.orgaoProcessoFilter = "";
        this.regionalProcessoFilter = "";
        this.varaProcessoFilter = "";
    };

    limparTiposMinuta = () => {
        this.possuiMinutaDespacho = false;
        this.possuiMinutaDecisao = false;
        this.possuiMinutaVoto = false;
        this.possuiMinutaVotoAgravoProvido = false;
    };

    limparPossuiPeticaoPendenteETiposPeticao = () => {
        this.possuiPeticaoPendente = false;
        this.tipoPeticaoSelecionadaFilter = [];
    };

    limparNaoPossuiPeticaoPendente = () => {
        this.naoPossuiPeticaoPendente = false;
    };

    limparPossuiImpedimentoETiposImpedimento = () => {
        this.possuiImpedimento = false;
        this.motivoImpedimentoSelecionadoFilter = ['Qualquer tipo'];
    };

    limparFiltro = (filtro) => {
        filtro.limparFiltro();
        this.procurar(false);
    };

    procurar = (_mostrarMensagem: boolean): void => {
        throw new Error('Implementa ai');
    }

    filtrarNumeroProcesso = (_processo: any/*Processo | ProcessoExterno */): void => {
        throw new Error('Implementa ai');
    }

filtrarPorListaDeNumeroProcesso = (_processo: any/*Processo | ProcessoExterno */): void => {
        throw new Error('Implementa ai');
    }

    filtrarResponsavel = (_processo: any/*Processo | ProcessoExterno */): void => {
        throw new Error('Implementa ai');
    }

    filtrarPorTipoMinuta = (_processo: any/*Processo | ProcessoExterno */): void => {
        throw new Error('Implementa ai');
    }

    filtrarPorJulgado = (_processo: any/*Processo | ProcessoExterno */): void => {
        throw new Error('Implementa ai');
    }

    filtrarPorPeticaoPendente = (_processo: any/*Processo | ProcessoExterno */): void => {
        throw new Error('Implementa ai');
    }

    filtrarPorImpedimento = (_processo: any/*Processo | ProcessoExterno */): void => {
        throw new Error('Implementa ai');
    }

    filtrarPorControleGabinete = (_processo: any/*Processo | ProcessoExterno */): void => {
        throw new Error('Implementa ai');
    }

    filtrarPorUsuario = (_processo: any/*Processo | ProcessoExterno */): void => {
        throw new Error('Implementa ai');
    }

    filtrarPorNomeParte = (_processo: any/*Processo | ProcessoExterno */): void => {
        throw new Error('Implementa ai');
    }

filtrarPorAssunto = (_processo: any/*Processo | ProcessoExterno */): void => {
        throw new Error('Implementa ai');
    }

    filtrarPorOrgaoJulgador = (_processo: any/*Processo | ProcessoExterno */): void => {
        throw new Error('Implementa ai');
    }

    filtrarPorEtiqueta = (_processo: any/*Processo | ProcessoExterno */): void => {
        throw new Error('Implementa ai');
    }

    filtrarPorIndicador = (_processo: any/*Processo | ProcessoExterno */): void => {
        throw new Error('Implementa ai');
    }

    filtrarPorAssinavelETipoDeMinuta = (_processo: any/*Processo | ProcessoExterno */): void => {
        throw new Error('Implementa ai');
    }

    filtrarPorClasse = (_processo: any/*Processo | ProcessoExterno */): void => {
        throw new Error('Implementa ai');
    }

    filtrarPorCategoria = (_processo: any/*Processo | ProcessoExterno */): void => {
        throw new Error('Implementa ai');
    }

    filtrarPorOrigem = (_processo: any/*Processo | ProcessoExterno */): void => {
        throw new Error('Implementa ai');
    }

    filtrarPorTema = (_processo: any/*Processo | ProcessoExterno */): void => {
        throw new Error('Implementa ai');
    }

    filtrarPorCampoDeTriagemBoolean = (_processo: any/*Processo | ProcessoExterno */): void => {
        throw new Error('Implementa ai');
    }
    filtrarPorCampoDeTriagemValorCondenacao = (_processo: any/*Processo | ProcessoExterno */): void => {
        throw new Error('Implementa ai');
    }
    filtrarPorCampoDeTriagemObservacao = (_processo: any/*Processo | ProcessoExterno */): void => {
        throw new Error('Implementa ai');
    }
    filtrarPorCpfsUltimaAlteracaoSituacaoMinuta = (_processo: any/*Processo | ProcessoExterno */): void => {
        throw new Error('Implementa ai');
    }


    nenhumParametroSelecionado(ignorarOrigem: boolean = false) {
        const possuiFiltroEstruturalNaUrl =
            (RouterStore.isEscaninhoGerencial || RouterStore.isEscaninhoFiltrado) &&
            ['controleNumero', 'responsavel', 'OJC'].some(
                parametro => RouterStore.getParam(parametro).length > 0
            );

        return !(this.numeroProcessoInformado
            || possuiFiltroEstruturalNaUrl
            || this.tarefaSelecionadaFilter?.length > 0
            || this.tipoMinutaFilter?.length > 0
            || this.orgaoJudicanteSelecionadoFilter?.length > 0
            || this.andTramTarefasSelecionadoFilter?.length > 0
            || this.etiquetaSelecionadaFilter?.length > 0
            || this.usuarioSelecionadoFilter?.length > 0
            || this.indicadorSelecionadoFilter?.length > 0
            || this.motivoImpedimentoSelecionadoFilter?.length > 0
            || this.assuntoFilter?.length > 0
            || this.categoriaProcessoFilter?.length > 0
            || this.situacaoMinutaFilter?.length > 0
            || this.revisorPautaFilter?.length > 0
            || this.statusRevisaoFilter?.length > 0
            || this.unidadePublicadoraFilter?.length > 0
            || this.resultadoJulgamentoFilter?.length > 0
            || this.usuariosUltimaAlteracaoSituacaoMinutaFilter?.length > 0
            || this.parteFilter?.length > 0
            || this.nomeParteFilter?.length > 0
            || this.classeProcessoFilter?.length > 0
            || this.classeInteiraFilter?.length > 0
            || this.temaProcessoFilter?.length > 0
            || this.classeInicialProcessoFilter?.length > 0
            || this.listaDeNumeroProcessoFilter?.length > 0
            || this.textoTriagemFilter?.length > 0
            || this.camposDeTriagemValorCondenacaoFilter?.length > 0
            || this.camposDeResponsavelPelaTriagemFilter?.length > 0
            || this.camposDeTriagemBooleanFilter?.length > 0
            || this.possuiMinutaDespacho
            || this.possuiMinutaDecisao
            || this.possuiMinutaVoto
            || this.possuiMinutaVotoAgravoProvido
            || this.naoPossuiMinuta
            || this.foraDoGabineteFilter
            || this.possuiResponsavel
            || this.possuiImpedimento
            || this.naoPossuiResponsavel
            || this.possuiRedatorDesignado
            || this.processoRetornandoAoGabinete
            || this.possuiPeticaoPendente
            || this.naoPossuiPeticaoPendente
            || this.julgadoFilter
            || this.naoJulgadoFilter
            || this.tipoJulgamentoPresencialFilter
            || this.tipoJulgamentoVirtualFilter
            || this.publicavelFilter
            || this.naoPublicavelFilter
            || this.favoritoFilter
            || this.naoFavoritoFilter
            || this.pautaFilter?.length > 0
            || this.movimentosFilter?.length > 0
            || this.assinavel
            || (!ignorarOrigem && this.origem)
            || this.anoAutuacaoFilter?.length > 0
            || this.situacaoPeticaoFilter?.length > 0
            || this.dataInicioPeticaoFilter?.length > 0
            || this.dataFimPeticaoFilter?.length > 0
            || this.filtrosFilter?.length > 0
            || this.votoLiberadoFilter
            || this.votoNaoLiberadoFilter
            || this.relatorProcessoFilter?.length > 0
            || this.correJuntoFilter
            || this.associadoFilter
        );
    }

    getNumeroProcesso = (numeroDeProcesso) => {
        this.numeroProcessoFilter = numeroDeProcesso.numero;
        this.digitoProcessoFilter = numeroDeProcesso.digito;
        this.anoProcessoFilter = numeroDeProcesso.ano;
        this.orgaoProcessoFilter = numeroDeProcesso.orgao;
        this.regionalProcessoFilter = numeroDeProcesso.regional;
        this.varaProcessoFilter = numeroDeProcesso.vara;
    };

    get numeroProcessoInformado() {
        return this.numeroProcessoFilter?.length > 0 ||
            this.digitoProcessoFilter?.length > 0 ||
            this.anoProcessoFilter?.length > 0 ||
            this.orgaoProcessoFilter?.length > 0 ||
            this.regionalProcessoFilter?.length > 0 ||
            this.varaProcessoFilter?.length > 0;
    }

    limparFiltros = () => {
        this.limparFiltrosBase();
    };

    limparFiltrosBase = () => {

        this.possuiResponsavel = false;
        this.naoPossuiResponsavel = false;
        this.possuiRedatorDesignado = false;
        this.processoRetornandoAoGabinete = false;
        this.possuiMinutaDespacho = false;
        this.possuiMinutaDecisao = false;
        this.possuiMinutaVoto = false;
        this.possuiMinutaVotoAgravoProvido = false;
        this.naoPossuiMinuta = false;
        this.foraDoGabineteFilter = false;
        this.incluirForaDoGabineteFilter = false;
        this.julgadoFilter = false;
        this.naoJulgadoFilter = false;
        this.classeProcessoFilter = [];
        this.classeInteiraFilter = [];
        this.tipoJulgamentoPresencialFilter = false;
        this.tipoJulgamentoVirtualFilter = false;
        this.publicavelFilter = false;
        this.naoPublicavelFilter = false;
        this.favoritoFilter = false;
        this.naoFavoritoFilter = false;
        this.possuiPeticaoPendente = false;
        this.naoPossuiPeticaoPendente = false;
        this.possuiImpedimento = false;
        this.assinavel = false;
        this.motivoImpedimentoSelecionadoFilter = [];
        this.orgaoJudicanteSelecionadoFilter = [];
        this.andTramTarefasSelecionadoFilter = [];
        this.filtrosFilter = [];
        this.tipoPeticaoSelecionadaFilter = [];
        this.dataInicioPeticaoFilter = '';
        this.dataFimPeticaoFilter = '';
        this.dataInicioPeticaoAplicada = '';
        this.dataFimPeticaoAplicada = '';
        this.situacaoPeticaoFilter = '';
        this.tarefaSelecionadaFilter = [];
        this.usuarioSelecionadoFilter = [];
        this.etiquetaSelecionadaFilter = [];
        this.indicadorSelecionadoFilter = [];
        this.tipoMinutaFilter = [];
        this.assuntoFilter = [];
        this.categoriaProcessoFilter = [];
        this.situacaoMinutaFilter = [];
        this.revisorPautaFilter = [];
        this.statusRevisaoFilter = [];
        this.unidadePublicadoraFilter = [];
        this.resultadoJulgamentoFilter = [];
        this.usuariosUltimaAlteracaoSituacaoMinutaFilter = [];
        this.listaDeNumeroProcessoFilter = '';
        this.textoTriagemFilter = '';
        this.camposDeTriagemValorCondenacaoFilter = '';
        this.camposDeResponsavelPelaTriagemFilter = [];
        this.numeroProcessoFilter = '';
        this.temaProcessoFilter = [];
        this.camposDeTriagemBooleanFilter = [];
        this.classeInicialProcessoFilter = [];
        this.nomeParteFilter = ''
        this.parteFilter = ''
        this.digitoProcessoFilter = '';
        this.anoProcessoFilter = '';
        this.orgaoProcessoFilter = '';
        this.regionalProcessoFilter = '';
        this.varaProcessoFilter = '';
        this.pautaFilter = [];
        this.movimentosFilter = [];
        this.origem = '';
        this.anoAutuacaoFilter = [];
        this.votoLiberadoFilter = false;
        this.votoNaoLiberadoFilter = false;
        this.relatorProcessoFilter = [];
        this.correJuntoFilter = false;
        this.associadoFilter = false;
        EscaninhoStore.processosPorTipoEscaninho.forEach(processo => {
            processo.resetMostrar();
        });
        this.procurar(false);
        this.limparAutocomplete();
        this.filtroAplicado = false;
    };

    private converterParaData = (valor: any): Date | null => {
        if (!valor) {
            return null;
        }

        let data: Date | null = null;

        if (valor instanceof Date) {
            data = new Date(valor.getTime());
        } else if (typeof valor === 'object' && valor.date) {
            data = new Date(valor.date.year, valor.date.month - 1, valor.date.day);
        } else if (typeof valor === 'string') {
            const somenteData = valor.trim().split(' ')[0].split('T')[0];
            const partesBr = somenteData.split('/');
            const partesIso = somenteData.split('-');
            if (partesBr.length === 3) {
                const [dia, mes, ano] = partesBr;
                data = new Date(Number(ano), Number(mes) - 1, Number(dia));
            } else if (partesIso.length === 3) {
                const [ano, mes, dia] = partesIso;
                data = new Date(Number(ano), Number(mes) - 1, Number(dia));
            } else {
                data = new Date(valor);
            }
        }

        if (!data || isNaN(data.getTime())) {
            return null;
        }

        data.setHours(0, 0, 0, 0);
        return data;
    };

    get intervaloDataPeticaoInvalido(): boolean {
        if (!RouterStore.isEscaninhoPeticao) {
            return false;
        }
        if (!this.dataInicioPeticaoFilter || !this.dataFimPeticaoFilter) {
            return false;
        }
        const inicio = this.converterParaData(this.dataInicioPeticaoFilter);
        const fim = this.converterParaData(this.dataFimPeticaoFilter);
        if (!inicio || !fim) {
            return false;
        }
        return inicio.getTime() > fim.getTime();
    }

    aplicarIntervaloDataPeticao = () => {
        this.dataInicioPeticaoAplicada = this.dataInicioPeticaoFilter || '';
        this.dataFimPeticaoAplicada = this.dataFimPeticaoFilter || '';
    };

    get possuiIntervaloDataPeticao(): boolean {
        if (!RouterStore.isEscaninhoPeticao) {
            return false;
        }
        return this.dataInicioPeticaoAplicada?.length > 0 || this.dataFimPeticaoAplicada?.length > 0;
    }

    private formatarDataParaExibicao = (dataIso: string): string => {
        if (!dataIso) {
            return '';
        }
        const [ano, mes, dia] = dataIso.split('-');
        if (ano && mes && dia) {
            return `${dia}/${mes}/${ano}`;
        }
        return dataIso;
    };

    get descricaoIntervaloDataPeticao(): string {
        const inicio = this.formatarDataParaExibicao(this.dataInicioPeticaoAplicada);
        const fim = this.formatarDataParaExibicao(this.dataFimPeticaoAplicada);

        if (inicio && fim) {
            return `${inicio} até ${fim}`;
        }
        if (inicio) {
            return `A partir de ${inicio}`;
        }
        if (fim) {
            return `Até ${fim}`;
        }
        return '';
    }

    peticaoDentroDoIntervaloDeData = (dataPeticao: any): boolean => {
        if (!this.possuiIntervaloDataPeticao) {
            return true;
        }

        const data = this.converterParaData(dataPeticao);
        if (!data) {
            return false;
        }

        if (this.dataInicioPeticaoAplicada) {
            const inicio = this.converterParaData(this.dataInicioPeticaoAplicada);
            if (inicio && data.getTime() < inicio.getTime()) {
                return false;
            }
        }

        if (this.dataFimPeticaoAplicada) {
            const fim = this.converterParaData(this.dataFimPeticaoAplicada);
            if (fim && data.getTime() > fim.getTime()) {
                return false;
            }
        }

        return true;
    };

    filtrarPeticoesPendentesPorData = (peticoes: PeticaoPendente[] = []): PeticaoPendente[] => {
        if (!this.possuiIntervaloDataPeticao) {
            return peticoes ?? [];
        }

        return (peticoes ?? []).filter(peticao =>
            this.peticaoDentroDoIntervaloDeData(peticao?.juntadoEm ?? peticao?.criadoEm));
    };

    limparAutocomplete = () => {
        const iconeClear = document.getElementsByName('AutocompleteGE');

        for (let i = 0; i < iconeClear.length; i++) {
            iconeClear[i].parentElement.click();
        }

    }

}

export default BaseFiltroStore;
